import $ from 'jquery';

// Sticky header
document.addEventListener("DOMContentLoaded", function(){
	window.addEventListener('scroll', function() {

		if (document.getElementById("header")) {

			const header = document.getElementById("header");

			if (window.scrollY > 50) {
		  	header.classList.add('fixed-top');		  
			} else {
		 	 header.classList.remove('fixed-top');
			}
		}
		
	});
}); 
// Sticky header END


// Fix Usercentrics vs. bootstrap ratio struggle 
const ucList = document.querySelectorAll(".uc-embedding-container");
for (let i = 0; i < ucList.length; i++) {
	ucList[i].parentElement.classList.add('ratio-with-uc');
}
// Fix Usercentrics vs. bootstrap ratio struggle END



/* Notification
==================================*/
$(function () {
	$('.notification_teaser').each(function(){
  
	  var note_id = $(this).attr('id');
  
	  $(this).find('.close').on('click', function () {
		$(this).closest('.notification_teaser').removeClass('in').animate({ 'margin-top': -1 * $(this).closest('.notification_teaser').outerHeight(), opacity: 0 }, 1000, function(){$(this).closest('.notification_teaser').hide()});
		$('body').removeClass('notification-in').animate({ 'padding-top': 0 }, 1000);
		$('header').animate({ 'top': 0 }, 1000);
		sessionStorage.setItem(note_id, 'off');
	  });
	  
	  $(this).css('margin-top', -1 * $(this).outerHeight());
	  if (!sessionStorage.getItem(note_id)) {
		$(this).delay(1000).addClass('in').animate({ 'margin-top': 0, opacity: 1 }, 1000);
		$('body').addClass('notification-in').delay(1000).animate({ 'padding-top': $(this).outerHeight() }, 1000);
		$('header').delay(1000).animate({ 'top': $(this).outerHeight() }, 1000);
	  }
	  else {
		$(this).hide();
	  }
	  $(document).on('keypress', function (e) {
		if (e.keyCode == 42) { sessionStorage.removeItem(note_id); console.log('sessionStorage cleared.') }
	  });
  
	});
  });
  